export enum HEADER_FLAG {
  allowHealthHelper = 'enable-health-helper',
}
